


























import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import UiInput from '@/components/ui/UiInput.vue'
import { masks } from '@/utils/plugins/inputMask'

interface Data {
  inputValue: string
  previousValue: string
  additionalLabel: string
}

interface Methods {
  onChange: (e: string) => void
  onInput: (e: string) => void
  onSelect: (e: any) => void
  onFocus: () => void
  onBlur: () => void
}

interface Computed {
  tabIndex: number
  refSelect: any
}

interface Props {
  labelField: string
  valueField: string
  additionalLabelField: string
  options: Array<any>
  value: any
  returnObject: boolean
  searchable: boolean
  onlyNumber: boolean
  optionsWidth: string
  optionsPosition: { [key: string]: string }
  error: boolean
  disabled: boolean
}

export default Vue.extend({
  name: 'UiSelect',
  components: {
    UiInput
  },
  model: {
    prop: 'value',
    event: 'select'
  },
  props: {
    labelField: {
      type: String,
      default: () => 'label'
    },
    valueField: {
      type: String,
      default: () => 'value'
    },
    additionalLabelField: {
      type: String,
      default: () => 'additionalLabel'
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number, Date],
      default: () => {}
    },
    returnObject: {
      type: Boolean,
      default: () => false
    },
    searchable: {
      type: Boolean,
      default: () => false
    },
    onlyNumber: {
      type: Boolean,
      default: () => false
    },
    optionsWidth: {
      type: String,
      default: () => '100%'
    },
    optionsPosition: {
      type: Object,
      default: () => {
        return { left: 0 }
      }
    },
    error: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      previousValue: '',
      inputValue: '',
      additionalLabel: '',
      masks
    }
  },
  computed: {
    additionalLabelMargin () {
      const charWidth = 10
      const paddingLeft = 12
      return this.inputValue.length * charWidth + paddingLeft + 'px'
    },
    tabIndex () {
      return this.disabled ? -1 : 0
    },
    refSelect () {
      return (this.$refs.select as any)
    }
  },
  watch: {
    value: {
      handler () {
        const currentObj = this.options.find(item => item[this.valueField] === this.value)
        this.inputValue = currentObj ? currentObj[this.labelField] : ''
        this.additionalLabel = currentObj ? currentObj[this.additionalLabelField] : ''
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onSelect (e: any) {
      this.refSelect.blur()
      if (this.returnObject) {
        this.$emit('select', e)
      } else {
        this.$emit('select', e[this.valueField])
      }
    },
    onInput (e: any): void {
      this.$emit('input', e)
    },
    onFocus (): void {
      if (this.searchable) {
        this.previousValue = this.inputValue
        this.inputValue = ''
      }
      this.$emit('focus')
    },
    onBlur (): void {
      if (this.searchable) {
        this.inputValue = this.previousValue
        if (this.options.length === 1) {
          this.onSelect(this.options[0])
        }
      }
      this.$emit('blur')
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
